module.exports = __webpack_public_path__ + "img/mobile-airport-logo.e21c0b39.jpg";